export default {
  props: {
    content: {
      default: () => [],
      required: true,
      type: Array
    },
    allowEditList: {
      default: () => [],
      required: true,
      type: Array
    },
    statuses: {
      default: () => [],
      required: true,
      type: Array
    },
    currencies: {
      default: () => {},
      required: true,
      type: Object
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    openDeleteConfirmationModal (record) {
      this.$emit('delete', record)
    },
    openDocument (record) {
      this.$emit('openDocument', record)
    },
    openCatalog (item) {
      this.$router.push({ name: 'catalog/document', params: { docId: item.doc_id, docName: item.name } })
    }
  }
}
